import Header from './Components/Header';

function InviteCandidatesPageHeader() {
    return (
        <div className="border-border bg-card">
            <div className="container mx-auto px-0">
                <div className="py-5">
                    <Header />
                </div>
            </div>
        </div>
    );
}

export default InviteCandidatesPageHeader;
